let sizeChart = document.querySelector('.newWrapsize');
let knowYourSize = document.querySelector('.know_your_size');
let element = document.querySelector('.kysInputs');
let metaObjString = element?.getAttribute('meta-obj');
let metaObj = metaObjString !== undefined ?  JSON.parse(atob(metaObjString)) : {} ;
let countRanges = {};
let sizeResult = '';
let finalResult = document.querySelector('.final_result');
let sizeChartColorHeading = document.querySelector(".sizePopheading h2");
let sizeChartHeading = document.querySelector('.sizeChartHeading');
let  knwoYourSizeHeading = document.querySelector('.knwoYourSizeHeading');

function displayKnowYourSize() {
  sizeChart.style.display = 'none';
  knowYourSize.style.display = 'block';
  sizeChartHeading.classList.remove('sizeActiveTab')
  knwoYourSizeHeading.classList.add('sizeActiveTab')
}

function displaySizeChart() {
  sizeChart.style.display = 'block';
  knowYourSize.style.display = 'none';
  sizeChartHeading.classList.add('sizeActiveTab')
  knwoYourSizeHeading.classList.remove('sizeActiveTab')
}

function maxLengthCheck(input) {
  if (input.value.length > 3) {
    input.value = input.value.slice(0, 3);
  }
  calculateSize();
}

function calculateSize() {
  const underBustInput = document.querySelector('.underBust__input');
  const overBustInput = document.querySelector('.overBust__input');

  if (underBustInput.value.length >= 2 && overBustInput.value.length >= 2) {
    sizeRange();
    searchInputValue(parseInt(underBustInput.value), parseInt(overBustInput.value));
  } else {
    finalResult.innerHTML = '';
  }
}

function searchInputValue(underBustValue, overBustValue) {
  let found = false;

  Object.entries(countRanges).forEach(([range, values], rangeIndex) => {
    const index = values.findIndex(value => value === underBustValue);
    if (index !== -1) {
      found = true;
      checkCupValue(rangeIndex, overBustValue);
    }
  });

  if (!found) {
    finalResult.innerHTML = "Entered values are incorrect, please click on the size chart to know more";
  }
}

function sizeRange() {
  metaObj.underbust_cms.forEach(item => {
    const [start, end] = item.split('-').map(Number);
    const range = Array.from({ length: end - start + 1 }, (_, index) => start + index);
    countRanges[item] = range;
  });
}

function checkCupValue(rangeIndex, overBustValue) {
  const cupKeys = Object.keys(metaObj).filter(key => key.startsWith('cup_'));
  let foundCup = '';

  cupKeys.forEach(cupKey => {
    const cupArray = metaObj[cupKey];
    const range = cupArray[rangeIndex].split('-').map(Number);
    const countingRange = Array.from({ length: range[1] - range[0] + 1 }, (_, index) => range[0] + index);

    if (countingRange.includes(overBustValue)) {
      foundCup = cupKey;
    }
  });

  if (foundCup !== '') {
    const braSize = metaObj.bra_size[rangeIndex];
    const cupLetter = foundCup.split('_')[1].toUpperCase();
    sizeResult = `${braSize}${cupLetter}`;
    finalResult.innerHTML = `YOUR BRA SIZE IS <span>${sizeResult}</span>`;
  } else {
    finalResult.innerHTML = "Entered values are incorrect, please click on the size chart to know more";
  }
}
